const Flex = ({ className = "", gap = 20, children }) => {
  return (
    <div className={`flex ${className}`} style={{ gap: `${gap}px` }}>
      {children}
    </div>
  )
}

export default Flex
